import { cloneDeep } from 'lodash';

const initialState = {
	snackbarShow: false,
	snackbarMsg: '',
	articles: {},
	products: {},
	edit: null,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case 'SET_SNACKBAR': {
			return {
				...state,
				snackbarMsg: action.value || state.snackbarMsg,
				snackbarShow: true,
			};
		}
		case 'SHOW_SNACKBAR': {
			return {
				...state,
				snackbarShow: true,
			};
		}
		case 'HIDE_SNACKBAR': {
			return {
				...state,
				snackbarShow: false,
			};
		}
		case 'SET_ARTICLES': {
			const { value, totalItems, statKey, page } = action;
			const newArticles = cloneDeep(state.articles);

			if (newArticles[statKey]) {
				newArticles[statKey][page] = value;
				newArticles[statKey].totalItems = totalItems;
			} else {
				newArticles[statKey] = {
					[page]: value,
					totalItems: totalItems,
				};
			}

			return {
				...state,
				articles: newArticles,
			};
		}
		case 'SET_PRODUCTS': {
			const { value, totalItems, statKey, page } = action;
			const newProducts = cloneDeep(state.products);

			if (newProducts[statKey]) {
				newProducts[statKey][page] = value;
				newProducts[statKey].totalItems = totalItems;
			} else {
				newProducts[statKey] = {
					[page]: value,
					totalItems: totalItems,
				};
			}

			return {
				...state,
				products: newProducts,
			};
		}
		case 'SET_SEARCH_EDIT': {
			return {
				...state,
				edit: action.value,
			};
		}
		default:
			return state;
	}
};
